import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store/store';
import { useState, useEffect } from 'react';
import { logout, setUser } from '../slices/authSlice'; // ✅ setUser importiert
import { useNavigate } from 'react-router-dom';
import { apiUrl } from '../config/api';

function ProfilePage() {
  const user = useSelector((state: RootState) => state.auth.user);
  const token = useSelector((state: RootState) => state.auth.token);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (user) {
      setUsername(user.username || '');
      setEmail(user.email || '');
    }
  }, [user]);

  const handleSave = async () => {
    const confirmed = window.confirm('Möchtest du die Änderungen speichern?');
    if (!confirmed) return;

    setError('');
    setLoading(true);

    try {
      // ✅ Profil (Name/Email) aktualisieren
      const resUser = await fetch(apiUrl('/api/users/me'), {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ username, email }),
      });

      if (!resUser.ok) {
        const errData = await resUser.json();
        throw new Error(errData.message || 'Fehler beim Aktualisieren');
      }

      const updatedUser = await resUser.json();
      dispatch(setUser(updatedUser)); // ✅ Redux sofort updaten

      // ✅ Passwort ändern (falls angegeben)
      if (password.trim()) {
        const resPass = await fetch(apiUrl('/api/users/me/password'), {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ password }),
        });

        if (!resPass.ok) {
          const errData = await resPass.json();
          throw new Error(errData.message || 'Fehler beim Passwort ändern');
        }

        alert('Passwort geändert. Bitte logge dich erneut ein.');
        dispatch(logout());
        navigate('/login');
        return;
      }

      alert('Profil erfolgreich aktualisiert.');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
      setPassword('');
    }
  };

  if (!user) {
    return <div className="container mt-5 text-center">Benutzerdaten werden geladen...</div>;
  }

  return (
    <div className="container mt-4" style={{ maxWidth: 500 }}>
      <h3 className="mb-4 text-center">Profil bearbeiten</h3>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="mb-3">
        <label className="form-label">Benutzername</label>
        <input
          className="form-control"
          value={username}
          onChange={e => setUsername(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">E-Mail</label>
        <input
          className="form-control"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
      </div>

      <div className="mb-4">
        <label className="form-label">Neues Passwort</label>
        <input
          className="form-control"
          type="password"
          placeholder="Nur ausfüllen, wenn ändern"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
      </div>

      <button className="btn btn-primary w-100" onClick={handleSave} disabled={loading}>
        {loading ? 'Speichern...' : 'Speichern'}
      </button>
    </div>
  );
}

export default ProfilePage;
